import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { fetchUserInfoIfNeeded } from '@pec/aion-ui-core/actions/userInfo';
import { mappedFeatureFlags } from '@pec/aion-ui-core/helpers/featureFlags';
import { syncBrowserTimeZone } from '@pec/aion-ui-i18next/helpers/syncBrowserTimeZone';
import { ThunkDispatch } from 'redux-thunk';
import { RootActions } from '@pec/aion-ui-core/combineActions';

export const TimeZoneSyncer: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<CommonRootState, null, RootActions>>();
  const userInfo = useSelector((state: CommonRootState) => state.userInfo.userInfo);
  const featureFlags = useSelector((state: CommonRootState) => state.featureFlags.featureFlags);

  React.useEffect(() => {
    dispatch(fetchUserInfoIfNeeded());
  }, [dispatch]);

  // Mirrors the FeatureFlagWrapper pattern: read flags from Redux so this works
  // outside FlagsProvider context. Re-runs when flags arrive (FeatureFlagWrapper
  // fetches them as a child).
  React.useEffect(() => {
    const isOverrideEnabled = mappedFeatureFlags(featureFlags).OverrideTimeZoneEnabled;
    if (userInfo?.userId && isOverrideEnabled) {
      syncBrowserTimeZone(userInfo.userId);
    }
  }, [userInfo, featureFlags]);

  return null;
};
